const CheckValidator = (errors: any, formData: any) => {
    return new Promise((resolve, reject) => {
        try {
            let d = true;
            const errorArr = Object.keys(errors);
            const errorArrLength = errorArr.length || 0;
            errorArr.forEach((i: any, j: number) => {
                if (errors[i]['required'] && (formData[i]?.length == 0 || formData[i] === null || formData[i] === 0)) {
                    errors[i]['message'] = errors?.[i]?.['message'] ? errors[i]['message'] : `${i} is required`;
                    errors[i]['error'] = true;
                    d = false;
                } else if (formData[i]?.length > 0 && errors?.[i]?.['pattern']) {
                    const regmob = new RegExp(errors?.[i]?.['pattern']);
                    if (!regmob.test(formData[i])) {
                        d = false;
                        errors[i]['message'] = `${i} is invalid. Please enter valid data`;
                        errors[i]['error'] = true;
                    }
                }
                if (j == errorArrLength - 1) {
                    resolve(d);
                }
            });
        } catch (error) {
            resolve(false);
        }
    });
};

export default CheckValidator;
